import { Button, Card, CardContent, Skeleton, View } from "@/components/ui";
import { CreditAccountInfo } from "./CreditAccountInfo";
import { CreditTransactionListCard } from "./credit-account-transaction/CreditTransactionListCard";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button";
import { useRoute } from "@/components/shared/router";
import { CreditAccountBanner } from "./CreditAccountBanner";
import type { CreditAccountProps } from "./CreditAccount.container";
import { CreditAccountExpiryList } from "./credit-account-expiry-list";
import { AccountMyReferralBanner } from "../account-my-referral/account-my-referral-banner";

export const CreditAccountScreen = ({
  loading,
  title,
  balance,
  transactions,
  onClickCard,
  onViewMore,
  type,
  canTopUp,
  canShowExpiryList,
  expiryType,
  isEmptyBalance,
  departmentLabel,
}: CreditAccountProps) => {
  const { pull } = useRoute();

  return (
    <View className="flex flex-col md:gap-6">
      <View className="static flex flex-1 flex-row items-center justify-between border-b">
        <View className="flex flex-row items-center gap-2 p-3 md:pl-0 md:pt-0">
          <IconButton
            iconName="arrowLeft"
            variant="secondary"
            rounded="full"
            color="foreground"
            className="w-[48px]"
            onClick={pull}
          />
          <Typography variant="label-md">{title}</Typography>
        </View>
      </View>
      {loading ? (
        <Skeleton />
      ) : (
        <CreditAccountBanner icon={type} balance={balance}>
          <View className="flex flex-1 flex-col items-center gap-3">
            {canShowExpiryList && expiryType && (
              <CreditAccountExpiryList type={expiryType} />
            )}
            {canTopUp && (
              <>
                {isEmptyBalance && departmentLabel && (
                  <Typography variant="caption-md">
                    {`Top up now to add ${departmentLabel} credit`}
                  </Typography>
                )}
                <Button
                  children="Top up"
                  variant="secondary"
                  color="CTA2"
                  iconName="plus"
                  iconAlignment="start"
                  iconColor="CTA2"
                  className="bg-white"
                  onClick={onClickCard}
                />
              </>
            )}
          </View>
        </CreditAccountBanner>
      )}
      <View className="p-4 md:p-0">
        <View className="flex flex-col gap-4">
          <CreditAccountInfo type={type} />
          {type === "general" && <AccountMyReferralBanner />}
          <Card>
            <CardContent>
              <View className="mb-3 flex flex-row items-center justify-between">
                <Typography variant="label-md">Transaction History</Typography>
              </View>
              <CreditTransactionListCard
                transactions={transactions}
                onViewMore={onViewMore}
              />
            </CardContent>
          </Card>
        </View>
      </View>
    </View>
  );
};
